
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import "../css/reservations-calendar.css";
import actions from "../js/actions.js";
import $$ from "dom7";
import URLS from "../js/Urls.js";

function resize() {
  // console.log("resize");
  // var windowsize = window.innerWidth;
  // console.log("windowsizeis", windowsize);
  var colsize = $$(".custcol").width(); // console.log("colsizeis", colsize);
  // var daycolsize = windowsize - colsize;
  // setTimeout(function () {
  //   $(".timeline-item").css("width", daycolsize);
  //   console.log($(".timeline-item"));
  // }, 0);

  $(".scrollercol").css("margin-left", colsize);
}

export default {
  // Lifecycle Hooks
  beforeCreate() {
    console.log("componentBeforeCreate", this);
  },

  // Component Data
  data: function () {
    // Must return an object
    return {
      PlanData: {},
      Info: {},
      loginobject: actions.LoginGetResult()
    };
  },
  // Component Methods
  methods: {
    openAlert: function () {
      var self = this;
      self.$app.dialog.alert("Hello World");
    },
    GetPlanData: async function () {
      app.f7.preloader.show();
      var info = actions.GetDashboardinfo();
      await actions.GetReservationsForPlan(" ", " ").then(value => {
        $$("#RoomID").show();
        this.$setState({
          PlanData: value,
          Info: info
        });
        app.f7.preloader.hide(); // console.log("pageAfterIn", page);

        $(window).on("resize", resize);
        resize();
        $(".calendarpage").on("scroll", function () {
          var scrollTop = $(".calendarpage").scrollTop();
          $(".timeline-item-content").scrollTop(scrollTop);
        }); // setTimeout(function () {
        //   $(".timeline-item-content").each(function (index) {
        //     var id = $(this).attr("id");
        //     $(`#${id}`).on("scroll", function () {
        //       var scrollTopnew = $(`#${id}`).scrollTop();
        //       $(".calendarpage").scrollTop(scrollTopnew);
        //       // console.log($(".calendarpage").scrollTop(scrollTopnew));
        //     });
        //   });
        // }, 10);
        // $(".timeline-item-content").on("scroll", function () {
        //   console.error($(".timeline-item-content").scrollTop());
        // });
      });
    }
  },
  // Page Events
  on: {
    pageMounted: async function (e, page) {},
    init: function (c) {},
    tabInit: async function (e, page) {
      var loginobject = actions.LoginGetResult();
      console.log("pageInit", page);
      this.GetPlanData();
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var allowClick = true;
      $(".page-current").on("click", ".cardtab", async function (event) {
        // ;
        let $target = $(event.target);
        let $date = $target.closest(".cardtab");
        var ReservationId = $date.attr("id");
        console.log("to id einai", ReservationId);
        var obj = {
          PropertyID: loginobject.PropertyID,
          UserID: loginobject.UserID,
          ReservationID: ReservationId
        };

        try {
          // $(".page-current").off("click", ".cardtab");
          app.preloader.show();
          let response = await app.request.promise.postJSON(URLS.GetReservationDetails, {
            obj
          }); // self.$setState({
          //   CalendarReservationDetails: response.data,
          // });
          // localStorage.setItem(
          //   "ReservationInfo",
          //   JSON.stringify(response.data.CustomerReservations[0])
          // );
          // app.f7.views.main.router.navigate("/reservation-info/", {
          //   transition: "f7-dive",
          // });
          // var calendarreserv = localStorage.getItem("ReservationInfo"); // pairnw thn opliroforia tou local storage
          // calendarreserv = JSON.parse(calendarreserv); // kanw parse thn pliroforia tou local storage
          // console.error("fwfwegw", calendarreserv);
          // console.error("to id einai",CustomId);

          self.$setState({
            ReservationInformation: response.data.CustomerReservations[0]
          });
          console.error("ffwdf", response.data.CustomerReservations[0]);
          localStorage.setItem("ReservationInfo", JSON.stringify(response.data.CustomerReservations[0]));
          app.views.main.router.navigate('/reservation-info/', {
            transition: 'f7-dive'
          }); //             var dynamicSheet = app.sheet.create({
          //               swipeToClose: true,
          //               backdrop:true,
          //               // swipeToStep: true,
          //               // backdrop: true,
          //               content:
          //                 `
          //                 <div
          //                         class="popup popup-swipe-to-close page-content "
          //                         style="overflow:scroll!important; background-color:#f7f7f7  "
          //                       >
          //           <div class="right" style="text-align:right; display:flex;justify-content:flex-end;">
          //             <!-- Link to close popup -->
          //             <a class="link popup-close" style="display:flex; align-items:end; justify-items:end; margin-right:20px;"><span class="material-icons-outlined" style="color:black; font-size:25px;">
          // x
          // </span></a>
          //           </div>
          //                         <div class="block " style="margin-top:0px;">
          //                           <div class="page">
          //                             <div class="page-content" style="display:none;"
          //                           <!-- <div class="sheet-modal-swipe-step">
          //                             <div
          //                               class="
          //                                 display-flex
          //                                 padding
          //                                 justify-content-space-between
          //                                 align-items-center
          //                               "
          //                             >
          //                               <div style="font-size: 18px"><b>Total:</b></div>
          //                               <div style="font-size: 22px"><b>$500</b></div>
          //                             </div>
          //                             <div class="padding-horizontal padding-bottom">
          //                               <a class="button button-large button-fill"
          //                                 >Make Payment</a
          //                               >
          //                               <div class="margin-top text-align-center">
          //                                 Swipe up for more details
          //                               </div>
          //                             </div>
          //                           </div> 
          //                           <!-- <div
          //                             class="block-title block-title-medium margin-top"
          //                           >
          //                             Your order:
          //                           </div> -->
          //                           <div class="card">
          //         <div class="card-content card-content-padding"></div>
          //           <div class ="row" style="display:flex; align-items:center; justify-content:center;">
          //             <div class="col-80">
          //          <!-- <div class="infclass" style="position:relative; display:flex; align-items:center; justify-content:center;"> 
          //          <div class ="privateInfo" name = "CustomerName" style="font-weight:bold; text-align:center; border:none; background-color:white;" value="" disabled>{{ReservationInformation.GuestName1}}</div> 
          //          <span class="material-icons edbt" style="font-size:14px; position:absolute; left:100%; display:none;">
          //           edit
          //           </span>  
          //         </div>  -->
          //         <div class ="privateInfo" name = "CustomerName" style="font-weight:bold; border:none; background-color:white; font-size:20px;" value="" disabled>` +
          //                 response.data.CustomerReservations[0].CustomerFirstName +
          //                 `  ` +
          //                 response.data.CustomerReservations[0].CustomerLastName +
          //                 `</div> 
          //         <!-- <div class ="privateInfo2" name = "CustomerSurname" style="font-weight:bold;  border:none; background-color:white;" value="" disabled ></div> -->
          //         <div class ="gendreCountry" name = "CustomerSurname" style="  border:none; background-color:white; color:#3fb4e9;" value="" disabled >Greece</div>
          //       </div> 
          //       <div class="col-20"><a class="material-icons-outlined">
          //       </a></div>  
          //           <!-- <a class="doEdit" style="color:#5ac8fa; position:absolute; right:0px; border:none;  display:inline-block; width:7%; background-color:white;" value="Edit"  disabled >Edit</a> -->
          //           </div>
          //           <div class ="row " style="display:flex; align-items:center; justify-content:center; padding-bottom:10px; padding-top:10px;">
          //             <div class="col-80">
          //             <div class ="privateInfo2" name = "CustomerSurname" style="font-weight:bold;  border:none; background-color:white;" value="" disabled >Mobile</div>
          //             <div class="infclass" style=""> 
          //             <div class ="takephone" name = "CustomerPhone" style="font-size:smaller;  width:100%; background-color:white; border:none;" value="" disabled >` +
          //                 response.data.CustomerReservations[0].GuestPhone1 +
          //                 ` </div><span class="material-icons edbt3" style="font-size:14px; position:absolute; left:100%; display:none;">
          //               edit
          //               </span></div>
          //           </div>
          //           <div class="col-20"><i class="icon material-icons md-only">call</i></div>
          //           </div>
          //           <!-- <div class ="row" style="display:flex; align-items:center; justify-content:center;">
          //             <div class="infclass" style="position:relative; display:flex; align-items:center; justify-content:center;"> 
          //             <div class ="privateInfo2" name = "CustomerSurname" style="font-weight:bold; text-align:center; border:none; background-color:white;" value="" disabled >{{ReservationInformation.GuestSurname1}}</div>
          //             <span class="material-icons edbt5" style="font-size:14px; position:absolute; left:100%; display:none;">
          //              edit
          //              </span>  
          //            </div>     
          //              </div> -->
          //              <div class ="row " style="display:flex; align-items:center; justify-content:center;">
          //               <div class="col-80">
          //                 <div class ="privateInfo2" name = "CustomerSurname" style="font-weight:bold;  border:none; background-color:white;" value="" disabled >Email</div>
          //               <div class="infclass" style=""> 
          //               <div class ="takeemail" name = "CustomerEmail" style="font-size:smaller;  width:100%; border:none; background-color:white; "  value="" disabled>` +
          //                 response.data.CustomerReservations[0].GuestEmail1 +
          //                 ` </div> <span class="material-icons edbt2" style="font-size:14px; position:absolute; left:100%; display:none;">
          //                 edit
          //                 </span></div> <a class="doSave" style="color:red; position:absolute; right:0px; border:none;  display:inline-block; width:7%; background-color:white; display:none;" value="Edit"  disabled >Save</a> 
          //             </div>
          //             <div class="col-20"><div class="col-20"><i class="icon material-icons md-only">message</i></div></div>
          //           </div>
          //           <!-- <div class ="row " style="display:flex; align-items:center; justify-content:center;">
          //             <div class="infclass" style="position:relative; display:flex; align-items:center; justify-content:center;"> 
          //             <div class ="takeemail" name = "CustomerEmail" style="font-size:smaller; text-align:center; width:100%; border:none; background-color:white; "  value="" disabled>{{ReservationInformation.GuestEmail1}}</div> <span class="material-icons edbt2" style="font-size:14px; position:absolute; left:100%; display:none;">
          //               edit
          //               </span></div> <a class="doSave" style="color:red; position:absolute; right:0px; border:none;  display:inline-block; width:7%; background-color:white; display:none;" value="Edit"  disabled >Save</a> 
          //           </div> -->
          //           <!-- <div class ="row " style="display:flex; align-items:center; justify-content:center;">
          //             <div class="infclass" style="position:relative; display:flex; align-items:center; justify-content:center;"> 
          //             <div class ="takephone" name = "CustomerPhone" style="font-size:smaller; text-align:center; width:100%; background-color:white; border:none;" value="" disabled >{{ReservationInformation.GuestPhone1}}</div><span class="material-icons edbt3" style="font-size:14px; position:absolute; left:100%; display:none;">
          //               edit
          //               </span></div>
          //           </div> -->
          //           <div class ="row " style="margin-top:15px;"></div>
          //           <!-- <div class="headerinfo" style="background-color:white; margin-bottom:-35px;">
          //               <div class=""  style="height: 100%; display:flex; align-items: center; justify-content: center; margin-left:-30px; ">
          //                 <div style="background-color:#518ab7; color:white; display:flex; text-align:center; align-items:center; width:3rem; height:3rem; font-size:22px; justify-content:center;"  class="UserInitIm2 MainRTGuestDetailsBC personinfo"><span class="" style="">{{CustomerInitialsFirstName}}{{CustomerInitialsLastName}}</span></div>
          //               </div>
          //           </div> -->
          //           <div class="row " style="width:63%; margin:0 auto;">
          //             <!-- <div class="col-25"  style="height: 100%; display:flex; align-items: center; justify-content: center; margin-left:-8px; ">
          //               <div class="" style="text-align:center; ">
          //                 <div style="background-color:#acc9e1; color:white; margin-bottom:4px; margin-left:15px; " class=" MainRTGuestDetailsBC personinfo booking-info-circle" >
          //                   <span class="material-icons reservIcon" > payment </span>
          //                 </div>
          //                 <div class="" style="color:black; font-size:small; margin-bottom:18px; text-transform:capitalize;" >Reservation</div>
          //               </div>
          //             </div> -->
          //             <!-- <div class="col-25"  style="height: 100%; display:flex; align-items: center; justify-content: center; margin-left:-8px; ">
          //               <div class="" style="text-align:center; ">
          //                 <div style="background-color:#acc9e1; color:white; margin-bottom:4px; " class=" MainRTGuestDetailsBC personinfo booking-info-circle" >
          //                  <span class="material-icons profileIcon"> account_circle </span>
          //                 </div>
          //                 <div class="" style="color:black; font-size:small; text-transform:capitalize;" >Profile</div>
          //               </div>
          //             </div> -->
          //             <!-- <div class="col-25"  style="height: 100%; display:flex; align-items: center; justify-content: center; margin-left:-8px; ">
          //               <div style="background-color:#acc9e1; color:white;" class="UserInitIm2 MainRTGuestDetailsBC personinfo"> <span class="material-icons"> account_circle </span><div class="" style="color:black; font-size:small; text-transform:capitalize;" >Profile</div></div>
          //             </div> -->
          //             <!-- <div class="col-25"  style="height: 100%; display:flex; align-items: center; justify-content: center; margin-left:-8px; ">
          //               <div class="" style="text-align:center; ">
          //                 <div style="background-color:#acc9e1; color:white; margin-bottom:4px; " class=" MainRTGuestDetailsBC personinfo booking-info-circle" >
          //                   <span class="material-icons noteIcon"> notes </span>
          //                 </div>
          //                 <div class="" style="color:black; font-size:small; text-transform:capitalize;"  >Notes</div>
          //               </div>
          //             </div> -->
          //             <!-- <div class="col-25"  style="height: 100%; display:flex; align-items: center; justify-content: center; margin-left:-8px; ">
          //               <div style="background-color:#acc9e1; color:white;" class="UserInitIm2 MainRTGuestDetailsBC personinfo"><span class="material-icons"> notes </span><div class="" style="color:black; font-size:small; text-transform:capitalize;" >Notes</div></div>
          //             </div> -->
          //             <!-- <div class="col-25"  style="height: 100%; display:flex; align-items: center; justify-content: center; margin-left:-8px; ">
          //               <div class="" style="text-align:center; ">
          //                 <div style="background-color:#acc9e1; color:white; margin-bottom:4px; " class=" MainRTGuestDetailsBC personinfo booking-info-circle" >
          //                   <span class="material-icons runIcon"> directions_run </span>
          //                 </div>
          //                 <div class="" style="color:black; font-size:small; text-transform:capitalize;" >Actions</div>
          //               </div>
          //             </div> -->
          //             <!-- <div class="col-25"  style="height: 100%; display:flex; align-items: center; justify-content: center; margin-left:-8px; ">
          //               <div style="background-color:#acc9e1; color:white;" class="UserInitIm2 MainRTGuestDetailsBC personinfo"> <span class="material-icons"> directions_run </span><div class="" style="color:black; font-size:small; text-transform:capitalize;" >Actions</div></div>
          //             </div>-->
          //           </div>  
          //           </div>
          //                               <!-- <div class="col-25"  style="height: 100%; display:flex; align-items: center; justify-content: center; margin-left:-8px; ">
          //                                   <div style="background-color:#acc9e1; color:white;" class="UserInitIm2 MainRTGuestDetailsBC personinfo"> <span class="material-icons"> directions_run </span><div class="" style="color:black; font-size:small; text-transform:capitalize;" >Actions</div></div>
          //                                 </div>-->
          //                             </div>
          //                           </div>
          //                           <div
          //                             class="block-title"
          //                             style="
          //                               font-weight: bold;
          //                               color: black;
          //                               font-size: initial;
          //                               margin-top:225px;
          //                             "
          //                           >
          //                             About this reservation - Room ` +
          //                 response.data.CustomerReservations[0].Room +
          //                 `
          //                           </div>
          //                           <span
          //                             style="position: relative; bottom: 14px; left: 14px"
          //                           >` +
          //                 response.data.CustomerReservations[0].ResID +
          //                 `</span>
          //                           <div class="card">
          //                             <div class="card-content card-content-padding" ">
          //                               <div class="row" style="position: relative">
          //                                 <div class="checkedin">
          //                                   Check-in
          //                                   <div
          //                                     class="col-50"
          //                                     style="font-weight: bold"
          //                                   >` +
          //                 response.data.CustomerReservations[0].CheckInDateString +
          //                 `</div>` +
          //                 response.data.CustomerReservations[0].CheckInTimeString +
          //                 `
          //                                 </div>
          //                                 <br />
          //                                 <br />
          //                                 <div
          //                                   class="divider col-10"
          //                                   style="
          //                                     border-left: 1px solid #c9d759;
          //                                     width: 2px;
          //                                     height: 45px;
          //                                     position: absolute;
          //                                     bottom: 0;
          //                                     left: 50%;
          //                                   "
          //                                 ></div>
          //                                 <div class="col-45 checkedout">
          //                                   Check-out
          //                                   <div class="" style="font-weight: bold">` +
          //                 response.data.CustomerReservations[0].CheckOutDateString +
          //                 `</div>` +
          //                 response.data.CustomerReservations[0].CheckOutTimeString +
          //                 `
          //                                 </div>
          //                               </div>
          //                               <br />
          //                               <div>
          //                                 <div class="row">
          //                                   <span class="material-icons" style="">
          //                                     room
          //                                   </span>
          //                                   <div class="col-90" style="">` +
          //                 response.data.CustomerReservations[0].Room +
          //                 `</div>
          //                                 </div>
          //                                 <div class="row">
          //                                   <span class="material-icons"> person </span
          //                                   ><span class="col-90"> ` +
          //                 response.data.CustomerReservations[0].Adults +
          //                 ` ενήλικες, ` +
          //                 response.data.CustomerReservations[0].Children +
          //                 ` παιδιά</span>
          //                                 </div>
          //                                 <div class="row">
          //                                   <span class="material-icons"> done_all </span
          //                                   ><span class="col-90" style="">` +
          //                 response.data.CustomerReservations[0].Nights +
          //                 ` βράδυ,` +
          //                 response.data.CustomerReservations[0].RoomCategory +
          //                 `  </span>
          //                                 </div>
          //                                 <div class="row">
          //                                   <span class="material-icons" style="">
          //                                     payment
          //                                   </span>
          //                                   <div class="the price col-90" style="">€` +
          //                 response.data.CustomerReservations[0].TotalPrice +
          //                 `</div>
          //                                 </div>
          //                               </div>
          //                               <!-- <div class= "row">
          //               <div class=" col-50" style="font-weight:bold;">Κυρ 10 Οκτ 2021</div>
          //             </div> -->
          //                               <!-- <div class= "row">15:00 μμ</div> -->
          //                               <!-- <br>
          //             <div class= "row">
          //               <div class=" col-50"><span class="material-icons"> single_bed </span>Room 512</div>
          //             </div>
          //             <div class= "row">
          //               <div class=" col-50">4 ενήλικες, 2 παιδιά</div>
          //             </div>
          //             <div class= "row">
          //               <div class=" col-50">1 βράδυ, 1 δωμάτιο</div>
          //             </div>
          //             <div class= "row">
          //               <div class=" col-50"><span class="material-icons"> payment </span>€ 131</div>
          //             </div>
          //           </div>  -->
          //                             </div>
          //                           </div>
          //                           <div class="accordion-item roomdetails">
          //                             <div class="accordion-item-toggle Dashboard">
          //                               <div class="row">
          //                                 <div class="col-70" id="roomId">
          //                                   Room Details
          //                                 </div>
          //                                 <div class="col-10"></div>
          //                                 <div
          //                                   class="col-20"
          //                                   style="
          //                                     display: flex;
          //                                     justify-content: flex-end;
          //                                   "
          //                                 >
          //                                   <span style="text-align: right">
          //                                     <i
          //                                       class="material-icons"
          //                                       style="color: #5ac8fa"
          //                                     >
          //                                       keyboard_arrow_down
          //                                     </i>
          //                                   </span>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                             <div class="accordion-item-content">
          //                               <div class="row">
          //                                 <div class="card">
          //                                   <div
          //                                     class="
          //                                       card-content card-content-padding
          //                                       takis
          //                                     "
          //                                   >
          //                                     <div class="list no-hairlines-md">
          //                                       <ul>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Room
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <a>` +
          //                 response.data.CustomerReservations[0].Room +
          //                 ` </a>
          //                                               <!-- <span class="input-clear-button"></span> -->
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Room Category
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <a>` +
          //                 response.data.CustomerReservations[0].RoomCategory +
          //                 `</a>
          //                                               <!-- <span class="input-clear-button"></span> -->
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Rate Name
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <a>` +
          //                 response.data.CustomerReservations[0].Rate +
          //                 `</a>
          //                                               <!-- <span class="input-clear-button"></span> -->
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                       </ul>
          //                                     </div>
          //                                   </div>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                           </div>
          //                           <div class="accordion-item guest">
          //                             <div class="accordion-item-toggle Dashboard">
          //                               <div class="row">
          //                                 <div class="col-70" id="guestId">Guests</div>
          //                                 <div class="col-10"></div>
          //                                 <div
          //                                   class="col-20"
          //                                   style="
          //                                     display: flex;
          //                                     justify-content: flex-end;
          //                                   "
          //                                 >
          //                                   <span style="text-align: right">
          //                                     <i
          //                                       class="material-icons"
          //                                       style="color: #5ac8fa"
          //                                     >
          //                                       keyboard_arrow_down
          //                                     </i>
          //                                   </span>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                             <div class="accordion-item-content">
          //                               <div class="row">
          //                                 <div class="card">
          //                                   <div
          //                                     class="
          //                                       card-content card-content-padding
          //                                       takis
          //                                     "
          //                                   >
          //                                     <div class="list no-hairlines-md">
          //                                       <ul>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Guest 1
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <!-- <div
          //                                                 class="item-after"
          //                                                 id="editbtnnewforguest1"
          //                                                 style="
          //                                                   display: table;
          //                                                   color: #3cb4eb;
          //                                                 "
          //                                               >
          //                                                 {{t 'edit'}}
          //                                               </div> -->
          //                                               <input
          //                                                 type="text"
          //                                                 name="GuestInfo1Name"
          //                                                 class="personInfo1"
          //                                                 value="` +
          //                 response.data.CustomerReservations[0].GuestName1 +
          //                 `"
          //                                                 disabled
          //                                               />
          //                                               <input
          //                                                 type="text"
          //                                                 name="GuestInfo1Surname"
          //                                                 class="personInfo"
          //                                                 value="` +
          //                 response.data.CustomerReservations[0].GuestSurname1 +
          //                 `"
          //                                                 disabled
          //                                               />
          //                                               <input
          //                                                 type="text"
          //                                                 name="GuestInfo1Email
          //                                                 class="personInfo"
          //                                                 value="` +
          //                 response.data.CustomerReservations[0].GuestEmail1 +
          //                 `"
          //                                                 disabled
          //                                               />
          //                                               <input
          //                                                 type="text"
          //                                                 name="GuestInfo1Phone"
          //                                                 class="personInfo"
          //                                                 value="` +
          //                 response.data.CustomerReservations[0].GuestPhone1 +
          //                 `"
          //                                                 disabled
          //                                               />
          //                                               <!-- <span class="input-clear-button"></span> -->
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                       </ul>
          //                                     </div>
          //                                   </div>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                           </div>
          //                           <div class="accordion-item">
          //                             <div class="accordion-item-toggle Dashboard">
          //                               <div class="row">
          //                                 <div class="col-70">Linked Profiles</div>
          //                                 <div class="col-10"></div>
          //                                 <div
          //                                   class="col-20"
          //                                   style="
          //                                     display: flex;
          //                                     justify-content: flex-end;
          //                                   "
          //                                 >
          //                                   <span style="text-align: right">
          //                                     <i
          //                                       class="material-icons"
          //                                       style="color: #5ac8fa"
          //                                     >
          //                                       keyboard_arrow_down
          //                                     </i>
          //                                   </span>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                             <div class="accordion-item-content">
          //                               <div class="row">
          //                                 <div class="card">
          //                                   <div
          //                                     class="
          //                                       card-content card-content-padding
          //                                       takis
          //                                     "
          //                                   >
          //                                     <div class="list no-hairlines-md">
          //                                       <ul>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Individual / Booker
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <a>` +
          //                 response.data.CustomerReservations[0].GuestName1 +
          //                 `   ` +
          //                 response.data.CustomerReservations[0].GuestSurname1 +
          //                 `</a>
          //                                               <span
          //                                                 class="input-clear-button"
          //                                               ></span>
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Company
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <a>` +
          //                 response.data.CustomerReservations[0].CompanyName +
          //                 `</a>
          //                                               <!-- <span class="input-clear-button"></span> -->
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Travel Agency
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <a>` +
          //                 response.data.CustomerReservations[0].TravelAgencyName +
          //                 `</a>
          //                                               <!-- <span class="input-clear-button"></span> -->
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Group
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <a>` +
          //                 response.data.CustomerReservations[0].GroupName +
          //                 `</a>
          //                                               <!-- <span class="input-clear-button"></span> -->
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Allotment
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <a>` +
          //                 response.data.CustomerReservations[0].AllotmentName +
          //                 `</a>
          //                                               <!-- <span class="input-clear-button"></span> -->
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               With Contact (Social Tourism)
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <a></a>
          //                                               <!-- <span class="input-clear-button"></span> -->
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                       </ul>
          //                                     </div>
          //                                   </div>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                           </div>
          //                           <!-- <div class="accordion-item">
          //                             <div class="accordion-item-toggle Dashboard">
          //                               <div class="row">
          //                                 <div class="col-70">Billing</div>
          //                                 <div class="col-10"></div>
          //                                 <div
          //                                   class="col-20"
          //                                   style="
          //                                     display: flex;
          //                                     justify-content: flex-end;
          //                                   "
          //                                 >
          //                                   <span style="text-align: right">
          //                                     <i
          //                                       class="material-icons"
          //                                       style="color: #5ac8fa"
          //                                     >
          //                                       keyboard_arrow_down
          //                                     </i>
          //                                   </span>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                             <div class="accordion-item-content">
          //                               <div class="row">
          //                                 <div class="card">
          //                                   <div
          //                                     class="
          //                                       card-content card-content-padding
          //                                       takis
          //                                     "
          //                                   >
          //                                     <div class="row">
          //                                       <div class="col-40"></div>
          //                                       <div
          //                                         class="progressbar col-50"
          //                                         id="progressbar-grey"
          //                                         data-progress="{{Progressbar}}"
          //                                       >
          //                                         <span></span>
          //                                       </div>
          //                                       <div class="col-10"></div>
          //                                     </div>
          //                                   </div>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                           </div> -->
          //                           <!-- <div class="accordion-item notes">
          //                             <div class="accordion-item-toggle Dashboard">
          //                               <div class="row">
          //                                 <div class="col-70" id="noteId">Notes</div>
          //                                 <div class="col-10"></div>
          //                                 <div
          //                                   class="col-20"
          //                                   style="
          //                                     display: flex;
          //                                     justify-content: flex-end;
          //                                   "
          //                                 >
          //                                   <span style="text-align: right">
          //                                     <i
          //                                       class="material-icons"
          //                                       style="color: #5ac8fa"
          //                                     >
          //                                       keyboard_arrow_down
          //                                     </i>
          //                                   </span>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                             <div class="accordion-item-content">
          //                               <div class="row">
          //                                 <div class="card">
          //                                   <div
          //                                     class="
          //                                       card-content card-content-padding
          //                                       takis
          //                                     "
          //                                   >
          //                                     <div class="list no-hairlines-md">
          //                                       <ul>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Note for reservation
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <div
          //                                                 class="item-after editNote1"
          //                                                 id="editbtnnew"
          //                                                 style="
          //                                                   display: table;
          //                                                   color: #3cb4eb;
          //                                                 "
          //                                               >
          //                                                 {{t 'edit'}}
          //                                               </div>
          //                                               <textarea
          //                                                 class="noteReservation"
          //                                                 name="NtReserv"
          //                                                 disabled
          //                                               ></textarea>
          //                                                <span class="input-clear-button"></span> -->
          //                           <!-- </div>
          //                                           </div>
          //                                         </li> -->
          //                           <!-- <li class="item-content item-input">
          //                                 <div class="item-inner">
          //                                   <div class="item-title item-label">Note for company</div>
          //                                   <div class="item-input-wrap">
          //                                     <div class="item-after editNote2"id="editbtnnew" style="display:table; color:#3cb4eb">{{t 'edit'}}</div>
          //                                     <textarea class="noteCompany" name= "NtComp" disabled></textarea>
          //                                   </div>
          //                                 </div>
          //                               </li> -->
          //                           <!-- <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Note for folio
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <div
          //                                                 class="item-after editNote3"
          //                                                 id="editbtnnew"
          //                                                 style="
          //                                                   display: table;
          //                                                   color: #3cb4eb;
          //                                                 "
          //                                               >
          //                                                 {{t 'edit'}}
          //                                               </div>
          //                                               <textarea
          //                                                 class="noteFolio"
          //                                                 name="NtFolio"
          //                                                 disabled
          //                                               ></textarea>
          //                                                <input type="password" placeholder="Note for folio" /> -->
          //                           <!-- <span class="input-clear-button"></span> -->
          //                           <!-- </div>
          //                                           </div>
          //                                         </li>
          //                                       </ul>
          //                                     </div>
          //                                   </div>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                           </div>  -->
          //                           <!-- <div class="accordion-item">
          //                             <div class="accordion-item-toggle Dashboard">
          //                               <div class="row">
          //                                 <div class="col-70">Transfer</div>
          //                                 <div class="col-10"></div>
          //                                 <div
          //                                   class="col-20"
          //                                   style="
          //                                     display: flex;
          //                                     justify-content: flex-end;
          //                                   "
          //                                 >
          //                                   <span style="text-align: right">
          //                                     <i
          //                                       class="material-icons"
          //                                       style="color: #5ac8fa"
          //                                     >
          //                                       keyboard_arrow_down
          //                                     </i>
          //                                   </span>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                             <div class="accordion-item-content">
          //                               <div class="row">
          //                                 <div class="card">
          //                                   <div
          //                                     class="
          //                                       card-content card-content-padding
          //                                       takis
          //                                     "
          //                                   >
          //                                     <div class="row">
          //                                       <div class="col-40"></div>
          //                                       <div
          //                                         class="progressbar col-50"
          //                                         id="progressbar-grey"
          //                                         data-progress="{{Progressbar}}"
          //                                       >
          //                                         <span></span>
          //                                       </div>
          //                                       <div class="col-10"></div>
          //                                     </div>
          //                                   </div>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                           </div> -->
          //                           <div class="accordion-item">
          //                             <div class="accordion-item-toggle Dashboard">
          //                               <div class="row">
          //                                 <div class="col-70">Segmentation</div>
          //                                 <div class="col-10"></div>
          //                                 <div
          //                                   class="col-20"
          //                                   style="
          //                                     display: flex;
          //                                     justify-content: flex-end;
          //                                   "
          //                                 >
          //                                   <span style="text-align: right">
          //                                     <i
          //                                       class="material-icons"
          //                                       style="color: #5ac8fa"
          //                                     >
          //                                       keyboard_arrow_down
          //                                     </i>
          //                                   </span>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                             <div class="accordion-item-content">
          //                               <div class="row">
          //                                 <div class="card">
          //                                   <div
          //                                     class="
          //                                       card-content card-content-padding
          //                                       takis
          //                                     "
          //                                   >
          //                                     <div class="list no-hairlines-md">
          //                                       <ul>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Origin
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <a>` +
          //                 response.data.CustomerReservations[0].OriginName +
          //                 ` </a>
          //                                               <!-- <span class="input-clear-button"></span> -->
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Source
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <a>` +
          //                 response.data.CustomerReservations[0].SourceName +
          //                 `</a>
          //                                               <!-- <span class="input-clear-button"></span> -->
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                         <li class="item-content item-input">
          //                                           <div class="item-inner">
          //                                             <div class="item-title item-label">
          //                                               Travel Reason
          //                                             </div>
          //                                             <div class="item-input-wrap">
          //                                               <a>` +
          //                 response.data.CustomerReservations[0].BusinessSegmentName +
          //                 `</a>
          //                                               <!-- <span class="input-clear-button"></span> -->
          //                                             </div>
          //                                           </div>
          //                                         </li>
          //                                       </ul>
          //                                     </div>
          //                                   </div>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                           </div>
          //                           <!-- <div class="accordion-item">
          //                             <div class="accordion-item-toggle Dashboard">
          //                               <div class="row">
          //                                 <div class="col-70">Policies</div>
          //                                 <div class="col-10"></div>
          //                                 <div
          //                                   class="col-20"
          //                                   style="
          //                                     display: flex;
          //                                     justify-content: flex-end;
          //                                   "
          //                                 >
          //                                   <span style="text-align: right">
          //                                     <i
          //                                       class="material-icons"
          //                                       style="color: #5ac8fa"
          //                                     >
          //                                       keyboard_arrow_down
          //                                     </i>
          //                                   </span>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                             <div class="accordion-item-content">
          //                               <div class="row">
          //                                 <div class="card">
          //                                   <div
          //                                     class="
          //                                       card-content card-content-padding
          //                                       takis
          //                                     "
          //                                   >
          //                                     <div class="policyCard">
          //                                       <div class="list no-hairlines-md">
          //                                         <ul>
          //                                           <li class="item-content item-input">
          //                                             <div class="item-inner">
          //                                               <div
          //                                                 class="item-title item-label"
          //                                               >
          //                                                 Cancellation Policy
          //                                               </div>
          //                                               <div class="item-input-wrap">
          //                                                 <a
          //                                                   class="
          //                                                     item-link
          //                                                     smart-select
          //                                                     smart-select-init
          //                                                     showsmartselect
          //                                                   "
          //                                                   data-open-in="sheet"
          //                                                 >
          //                                                   <select name="mac-windows">
          //                                                     <option
          //                                                       value="{{CancellationID}}"
          //                                                     ></option>
          //                                                   </select>
          //                                                   <div class="item-content">
          //                                                     <div class="item-inner">
          //                                                       <div
          //                                                         class="item-title"
          //                                                       ></div>
          //                                                     </div>
          //                                                   </div>
          //                                                 </a> -->
          //                           <!-- <textarea placeholder="Basic Cancellation Policy"></textarea> -->
          //                           <!-- <span class="input-clear-button"></span> -->
          //                           <!-- </div>
          //                                             </div>
          //                                           </li>
          //                                           <li class="item-content item-input">
          //                                             <div class="item-inner">
          //                                               <div
          //                                                 class="item-title item-label"
          //                                               >
          //                                                 Payment Policy
          //                                               </div>
          //                                               <div class="item-input-wrap">
          //                                                 <a
          //                                                   class="
          //                                                     item-link
          //                                                     smart-select
          //                                                     smart-select-init
          //                                                     showsmartselect2
          //                                                   "
          //                                                   data-open-in="sheet"
          //                                                 >
          //                                                   <select name="mac-windows">
          //                                                     <option value=""></option>
          //                                                   </select>
          //                                                   <div class="item-content">
          //                                                     <div
          //                                                       class="item-inner arrow"
          //                                                     >
          //                                                       <div
          //                                                         class="item-title"
          //                                                       ></div>
          //                                                     </div>
          //                                                   </div>
          //                                                 </a>
          //                                                 <a></a> -->
          //                           <!-- <span class="input-clear-button"></span> -->
          //                           <!-- </div>
          //                                             </div>
          //                                           </li>
          //                                         </ul>
          //                                       </div>
          //                                     </div>
          //                                   </div>
          //                                 </div>
          //                               </div>
          //                             </div>
          //                           </div> -->
          //                         </div>
          //                       </div>
          //         `,
          //             // Events
          //             on: {
          //               opened: function (sheet) {
          //                 console.log('Sheet opened');
          //                 app.preloader.hide();
          //               },
          //             }
          //             });
          //             dynamicSheet.open();
        } catch (error) {
          console.log(error);
        }
      }); // $(".page-current").on("click", "#clickme2", function (event) {
      //   // app.f7.views.main.router.navigate("/main/reservations/", {
      //   //   transition: "f7-dive",
      //   // });
      // });
    },
    pageBeforeIn: function (e, page) {
      console.log("pageBeforeIn", page);
    },
    pageAfterIn: function (e, page) {
      console.log("coldaysizeis", daycolsize);
    },
    pageBeforeOut: function (e, page) {
      console.log("pageBeforeOut", page);
    },
    tabMounted: function (e, page) {},
    pageBeforeRemove: function (e, page) {
      console.log("pageBeforeRemove", page);
    }
  },
  id: '4738dcdbca',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=reservationscalendar><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link icon-only panel-open" data-panel=left><i class="icon f7-icons if-not-md">menu</i> <i class="icon material-icons if-md">menu</i></a></div><div class="title sliding">';
      r += Template7Helpers.t.call(ctx_1, 'reservationsCalendar', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><div class="page-content calendarpage" style="padding-bottom: 40px"><div class="row no-gap custmrow"><div class="col-30 custcol"><div id=RoomID hidden class="" style="position: fixed;\n              width: inherit;\n              z-index: 10;\n              height: 63px;\n              background-color: #222933;\n              text-align: center;\n              box-shadow: 0px 2px 0px #222933;"><span class=roomslabel>Rooms</span></div><div class=Roomlabel style="margin-top: 54px">';
      r += Template7Helpers.each.call(ctx_1, ctx_1.Info.Rooms, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=card><div class=customchip><span class="" style="color: white">';
          r += c(ctx_2.RoomName, ctx_2);
          r += '</span> <span class="" style="color: white">';
          r += c(ctx_2.RoomTypeCode, ctx_2);
          r += '</span></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div><div class="col-70 custcol scrollercol" style="position: fixed; margin-left: 128px"><!--Calendar--><div class="timeline timeline-horizontal col-40 tablet-20" style="overflow-x: auto"><!-- Timeline Year --> ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.PlanData.TimelineYears, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=timeline-year><!-- Timeline Year Title --><div class=timeline-year-title><span>';
          r += c(ctx_2.Year, ctx_2);
          r += '</span></div>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.TimelineMonths, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<!-- Timeline Month --><div class=timeline-month><!-- Timeline Month Title --><div class=timeline-month-title style="position: absolute; margin-top: -17px"><span>';
              r += Template7Helpers.Getmonthname.call(ctx_3, ctx_3.Month, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span></div>';
              r += Template7Helpers.each.call(ctx_3, ctx_3.TimelineDays, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<!-- Timeline Month Items --><div class=timeline-item style="margin-top: -17px"><div class=timeline-item-date>';
                  r += c(ctx_4.Day, ctx_4);
                  r += '</div><div class=timeline-item-content id=timeline-item-content-';
                  r += c(ctx_4.Day, ctx_4);
                  r += ' style="overflow: hidden; padding-top: 0.5px">';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.TimelineRooms, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '<!--Each Room--> ';
                      r += Template7Helpers.js_if.call(ctx_5, "(this.Events).length >0 ", {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += ' ';
                          r += Template7Helpers.js_if.call(ctx_6, "(this.Events).length ==1 ", {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += ' ';
                              r += Template7Helpers.each.call(ctx_7, ctx_7.Events, {
                                hash: {},
                                data: data_7 || {},
                                fn: function (ctx_8, data_8) {
                                  var r = '';
                                  r += '<!--Na typwsei tat stoixeia mono an einai idia h mera me thn hmeromhnia tou checkin--> ';
                                  r += Template7Helpers.js_if.call(ctx_8, "this.DontPrintHeader == 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += '<div class="card cardtab';
                                      r += c(ctx_9.ExtraClass, ctx_9);
                                      r += ' ';
                                      r += c(ctx_9.ReservatinID, ctx_9);
                                      r += ' button button-fill" style="background-color: ';
                                      r += c(ctx_9.Colour, ctx_9);
                                      r += ';" id=';
                                      r += c(ctx_9.ReservatinID, ctx_9);
                                      r += '><div class=timeline-item-text>';
                                      r += c(ctx_9.EventInfoTop, ctx_9);
                                      r += '</div><div class=timeline-item-text>';
                                      r += c(ctx_9.EventInfoBottom, ctx_9);
                                      r += '</div></div>';
                                      return r;
                                    },
                                    inverse: function (ctx_9, data_9) {
                                      var r = '';
                                      r += '<div class="card cardtab ';
                                      r += c(ctx_9.ExtraClass, ctx_9);
                                      r += ' ';
                                      r += c(ctx_9.ReservatinID, ctx_9);
                                      r += '" style="background-color: ';
                                      r += c(ctx_9.Colour, ctx_9);
                                      r += ';" id=';
                                      r += c(ctx_9.ReservatinID, ctx_9);
                                      r += '><div class=timeline-item-title>';
                                      r += c(ctx_9.Guest, ctx_9);
                                      r += '</div><div class=timeline-item-text>';
                                      r += c(ctx_9.TotalPrice, ctx_9);
                                      r += ' ';
                                      r += c(ctx_9.Currency, ctx_9);
                                      r += '</div><span class=';
                                      r += c(ctx_9.SplitRoomClass, ctx_9);
                                      r += '></span></div>';
                                      return r;
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += ' ';
                                  return r;
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += ' ';
                              r += Template7Helpers.js_if.call(ctx_7, "this.DontPrintHeader == 1", {
                                hash: {},
                                data: data_7 || {},
                                fn: function empty() {
                                  return '';
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              return r;
                            },
                            inverse: function (ctx_7, data_7) {
                              var r = '';
                              r += '<div class="row card">';
                              r += Template7Helpers.each.call(ctx_7, ctx_7.Events, {
                                hash: {},
                                data: data_7 || {},
                                fn: function (ctx_8, data_8) {
                                  var r = '';
                                  r += ' ';
                                  r += Template7Helpers.js_if.call(ctx_8, "this.DontPrintHeader == 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += '<div class="col-50 custom2cardsleft cardtab ';
                                      r += c(ctx_9.ExtraClass, ctx_9);
                                      r += ' ';
                                      r += c(ctx_9.ReservationID, ctx_9);
                                      r += '" style="height: 100%;width:49%;background-color: ';
                                      r += c(ctx_9.Colour, ctx_9);
                                      r += ';" id=';
                                      r += c(ctx_9.ReservatinID, ctx_9);
                                      r += '><div class=timeline-item-text>';
                                      r += c(ctx_9.EventInfoTop, ctx_9);
                                      r += '</div><div class=timeline-item-text>';
                                      r += c(ctx_9.EventInfoBottom, ctx_9);
                                      r += '</div></div>';
                                      return r;
                                    },
                                    inverse: function (ctx_9, data_9) {
                                      var r = '';
                                      r += '<div class="col-50 custom2cardsleft cardtab';
                                      r += c(ctx_9.ExtraClass, ctx_9);
                                      r += ' ';
                                      r += c(ctx_9.ReservationID, ctx_9);
                                      r += '" id=';
                                      r += c(ctx_9.ReservatinID, ctx_9);
                                      r += ' style="height: 100%;width:49%;background-color: ';
                                      r += c(ctx_9.Colour, ctx_9);
                                      r += ';"><div class=""><div class=timeline-item-title>';
                                      r += c(ctx_9.Guest, ctx_9);
                                      r += '</div><div class=timeline-item-text>';
                                      r += c(ctx_9.TotalPrice, ctx_9);
                                      r += ' ';
                                      r += c(ctx_9.Currency, ctx_9);
                                      r += '</div><span class=';
                                      r += c(ctx_9.SplitRoomClass, ctx_9);
                                      r += '></span></div></div>';
                                      return r;
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += ' ';
                                  return r;
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += '</div>';
                              return r;
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += ' ';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '<div class=card style="background-color: transparent; box-shadow: none"></div>';
                          return r;
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += ' ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '</div></div>';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};
    